import React from "react";
import classes from "./skills.module.css";
import "../../Main.css";

import Html5Icon from "../../img/html-5.svg";
import Css3Icon from "../../img/css-3.svg";
import JsIcon from "../../img/js.svg";
import JavaIcon from "../../img/java.svg";
import SwiftIcon from "../../img/swift.png";
// import PythonIcon from "../../img/python.png";
// import AngularIcon from "../../img/angular.svg";
// import JQueryIcon from "../../img/jquery.svg";
import NodeIcon from "../../img/node.png";
import ReactIcon from "../../img/react.svg";
import ReduxIcon from "../../img/redux.svg";
import GitIcon from "../../img/git.svg";
import IonicIcon from "../../img/ionic.png";
import TypeScript from "../../img/typescript.png";
import BootstrapIcon from "../../img/bootstrap.svg";
import { Link } from "react-router-dom";

import scrollAndPageFlip from "../../Utils/PageFlipAndScrollTop";

const Skills = () => {
  return (
    <div className={[classes.SkillsPage, "flex-content", "Page"].join(" ")}>
      <h1 datatype="Skills">Skills</h1>

      <div className={classes.Skills}>
        <div className={classes.Languages}>
          <h2 datatype="Skills">Languages</h2>
          <ul>
            <li>
              <img src={Html5Icon} alt="Html 5 icon" />
              <span>HTML5</span>
            </li>
            <li>
              <img src={Css3Icon} alt="Css 3 icon" />
              <span>CSS3</span>
            </li>
            <li>
              <img
                style={{ borderRadius: "20px" }}
                src={JsIcon}
                alt="JS icon"
              />
              <span>JavaScript</span>
            </li>
            <li>
              <img
                style={{ borderRadius: "20px" }}
                src={TypeScript}
                alt="TypeScript icon"
              />
              <span>TypeScript</span>
            </li>
            <li>
              <img style={{ width: "24px" }} src={JavaIcon} alt="Java icon" />
              <span>Java</span>
            </li>
            <li>
              <img style={{ width: "24px" }} src={SwiftIcon} alt="Swift icon" />
              Swift
            </li>
            {/* <li>
              <img
                style={{ width: "24px" }}
                src={PythonIcon}
                alt="Python icon"
              />
              <span>Python</span>
            </li> */}
          </ul>
        </div>

        <div className={classes.DevTools}>
          <h2 datatype="Skills">Dev Tools</h2>
          <ul>
            <li>
              <img src={GitIcon} alt="Git icon" />
              <span>Git</span>
            </li>
            <li>
              <img src={ReduxIcon} alt="Redux icon" />
              <span>Redux</span>
            </li>
            <li>
              <img
                style={{ width: "24px" }}
                src={BootstrapIcon}
                alt="Bootstrap Icon"
              />
              <span>Bootstrap</span>
            </li>
            {/* <li>
              <img src={JQueryIcon} alt="JQuery icon" />
              <span>JQuery</span>
            </li> */}
          </ul>
        </div>

        <div className={classes.DesingTools}>
          <h2 datatype="Skills">Frameworks and Libraries</h2>
          <ul>
            <li>
              <img
                className={classes.SpinIcon}
                src={ReactIcon}
                alt="React icon"
              />
              <span>React</span>
            </li>
            {/* <li>
              <img src={AngularIcon} alt="Angular icon" />
              <span>Angular</span>
            </li> */}
            <li>
              <img src={NodeIcon} alt="Node icon" />
              <span>Node</span>
            </li>
            <li>
              <img src={IonicIcon} alt="Ionic icon" />
              <span>Ionic</span>
            </li>
          </ul>
        </div>
      </div>

      <p>
        You must be wondering what I have done with all the things above. Well,
        <Link onClick={scrollAndPageFlip} to="/portfolio">
          {" "}
          here you go
        </Link>
        .
      </p>
    </div>
  );
};

export default Skills;
